<template>
  <div>

    <b-row  style="border-top: 2px solid #9e9e9e;padding: 7px;padding-top:10px;padding-bottom:0;background-color: #fff" :style="{borderTop: headerStyles(issue)}">



      <b-col md="2" cols="3" class="my-0">
        <b-badge  v-if="issue.board" pill variant="info" class="text-right p-1" style="float: right"
                  :style="{backgroundColor: boardColor(issue.board.id)}">
          {{issue.board.title}}
        </b-badge>

      </b-col>

      <b-col  md="10" cols="9" class="my-0"  style="min-width: 200px">
        <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h6>



      </b-col>

      <b-col v-if="issueMoreDetailShow"  md="2" cols="3" class="my-1" >


        <span v-b-tooltip.hover title="اولویت زیاد" v-if="issue.priority == 3"  class="text-right text-danger" size="sm"><i class="fas fa-thermometer-full"></i></span>
        <span v-b-tooltip.hover title="اولویت متوسط" v-else-if="issue.priority == 2"   class="text-right text-dark" size="sm" ><i class="fas fa-thermometer-half"></i></span>
        <span v-b-tooltip.hover title="اولویت کم" v-else-if="issue.priority == 1"   class="text-right text-secondary" size="sm" ><i class="fas fa-thermometer-empty"></i></span>




      </b-col>

      <b-col v-if="issueMoreDetailShow"  md="6" cols="5" class="my-1" >





        <router-link :to="{path :'/issue/history/'+issue.id }"
                     :id="'tooltip-target-issueShowHistory-'+issue.id"
                     style="cursor: pointer" class="text-default  ml-2">
          <i class="fas fa-fast-forward"></i>
        </router-link>
        <b-tooltip placement="bottom"  :target="'tooltip-target-issueShowHistory-'+issue.id"
                   triggers="hover">
          <small>  گذشته Issue</small>
        </b-tooltip>




                                          <span v-if="issue.contact_id && issue.contact"  :id="'tooltip-target-'+issue.id"
                                                style="cursor: pointer" class="text-success  ml-2" @click="$router.push({ path:'/contact/profile/'+issue.contact_id, params: {id:issue.contact_id}})" >
                                              <i class="fas fa-address-book"></i>
                                          </span>
        <b-tooltip   placement="bottom" v-if="issue.contact_id && issue.contact" :target="'tooltip-target-'+issue.id" triggers="hover">
          <small>مشتری: </small>
          {{issue.contact.last_name}}
        </b-tooltip>






        <span v-if="issue.project_id && issue.project" :id="'tooltip-target-project-'+issue.id"
              style="cursor: pointer" class="text-info ml-2" >
                                              <i class="fas fa-handshake"></i>
                                          </span>
        <b-tooltip  placement="bottom" v-if="issue.project_id && issue.project" :target="'tooltip-target-project-'+issue.id" triggers="hover">
          <small>پروژه: </small>
          {{issue.project.title}}
        </b-tooltip>




        <span v-if="issue.process">
                        <span  v-if="issue.process.steps" >
                              <span v-for="(step, stepIconListIndex) in issue.process.steps" v-if="step.id === issue.step_id" :key="'stepIconList'+stepIconListIndex" :id="'tooltip-target-step-'+issue.id"
                                    style="cursor: pointer" class="text-dark ml-2" >
                                              <i class="fas fa-random"></i>
                    </span>
                            <b-tooltip v-for="(step, stepTooltipListIndex) in issue.process.steps" v-if="step.id === issue.step_id"  :key="'stepTooltipList'+stepTooltipListIndex"   placement="bottom"  :target="'tooltip-target-step-'+issue.id" triggers="hover">
                                <small>مرحله: </small>
                                {{step.title}}
                            </b-tooltip>
                        </span>
                    </span>






        <span  :id="'tooltip-target-created-'+issue.id"
               style="cursor: pointer" class="text-secondary  ml-2" >
                                              <i class="fas fa-calendar"></i>
                                          </span>
        <b-tooltip   placement="bottom"  :target="'tooltip-target-created-'+issue.id" triggers="hover">
          <small>تاریخ ثبت: </small>
          {{issue.created_at| moment("dddd, jD jMMMM") }}
        </b-tooltip>





      </b-col>

      <b-col v-if="issueMoreDetailShow"  md="4" cols="4"  class="my-1 text-left text-sm"  >
        <!--                                          <small>-->
        <!--                                              <b-col md="12" class="text-left text-sm">-->
        <!--                                                  <small>-->

        <!--                                                      <router-link  v-if="issue.contact_id && issue.contact" :title="issue.contact.first_name +' '+issue.contact.last_name" :to="{path: '/contact/profile/'+issue.contact_id, params: {id: issue.contact_id}}"-->
        <!--                                                                   class="btn btn-success btn-sm" size="sm">-->
        <!--                                                          مشتری:-->

        <!--                                                          {{issue.contact.last_name}}-->
        <!--                                                      </router-link>-->

        <!--                                                  </small>-->
        <!--                                              </b-col>                                          </small>-->



        <!--                                          <b-badge  v-if="issue.contact_id && issue.contact" size="sm" variant="success"   class=" m-1" >-->
        <!--                                              <small>مشتری: </small>-->
        <!--                                              {{issue.contact.last_name}}</b-badge>-->


        <!--                                          <b-badge v-if="issue.project" size="sm" variant="info"   class=" m-1">-->
        <!--                                              <small>پروژه: </small>-->
        <!--                                              {{issue.project.title}}</b-badge>-->




        <!--                                          <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >-->
        <!--&lt;!&ndash;                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>&ndash;&gt;-->
        <!--                                                    <b-badge  v-if="step.id === issue.step_id" variant="light">{{step.title}}</b-badge>-->
        <!--                                              &lt;!&ndash;                                                    <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>&ndash;&gt;-->
        <!--                                                </span>-->





        <small class="text-color-blue mt-1 mr-2" >

          <span v-if="issue.type_object" v-b-tooltip.hover :title="issueTypeText(issue)" v-text="issue.type_object.title" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}"></span>

        </small>
      </b-col>



    </b-row>








    <b-row class="mb-5">
      <b-col  style="background-color: #f6f6f6; color: #333">

        <issueItemShow  :issue="issue" :issueMoreDetailShow="issueMoreDetailShow" >
        </issueItemShow>

      </b-col>
    </b-row>





  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

import InnerImageZoom from 'vue-inner-image-zoom';



import lodash from 'lodash'
import issueItemShow from "./item";




export default {
  name: 'issueShow',
  components: {


      Multiselect,

    issueItemShow,


      'inner-image-zoom': InnerImageZoom








  },



    props: {

    },


    data () {
        return {

            auth: {
                headers: {
                    Authorization: 'bearer ' + localStorage.getItem('token')
                }
            },

            role: localStorage.getItem('role'),
            authUser:
                {
                    id:localStorage.getItem('id'),
                },

            loadMore: true,
            page: 1,
            pageSize: 10,
            voice: '',

            courseCategories:[],
            fileCategories:[],
            forumCategories:[],
            forums:[],


            issue:{},


            rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

          issueMoreDetailShow:true,

          issueId:null,

        }
    },



    watch: {

        },



  beforeRouteUpdate(to, from, next) {

    // this.issueId = to.params.id
    this.getIssue(to.params.id)

    next();
  },


    mounted() {

       this.issueId = this.$route.params.id
       this.getIssue(this.issueId)

    },



    methods: {






      getIssue($id){
        var app = this;

        axios.get('/api/intro/issue/show/'+$id , app.auth)
            .then(function (response) {
              app.issue = response.data
              // console.log(response.data);
            })
            .catch(function (e) {
              console.log(e.response);
            });
      },






      color (value) {
            let $color
            if (value <= 25) {
                $color = 'info'
            } else if (value > 25 && value <= 50) {
                $color = 'success'
            } else if (value > 50 && value <= 75) {
                $color = 'warning'
            } else if (value > 75 && value <= 100) {
                $color = 'danger'
            }
            return $color
        },

        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },

        showIssueText(text, index ){

            this.issues[index].intro = text

        },

        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        headerStyles(issueType){
            if (issueType.type == 1)
                return '2px solid #880e4e'
            else if (issueType.type == 2)
                return '2px solid #f50057'
            else if (issueType.type == 3)
                return '2px solid #8e24aa'
            else if (issueType.type == 4)
                return '2px solid #263238'
            else if (issueType.type == 5)
                return '2px solid #dd2c00'
            else if (issueType.type == 6)
                return '2px solid #00c853'
            else if (issueType.type == 7)
                return '2px solid #0097a7'
            else if (issueType.type == 8)
                return '2px solid #0288d1'
            else if (issueType.type == 9)
                return '2px solid #0208ff'
            else if (issueType.type == 10)
                return '2px solid #eeb600'
            else if (issueType.type == 10)
                return '2px solid #0e8e2e'
            else if (issueType.type == 11)
                return '2px solid #888'
            else
                return '2px solid #888888'
        },

        boardColor(boardID){
            if (boardID == 1)
                return '#ee6600'
            else if (boardID == 2)
                return '#ffd600'
            else if (boardID == 3)
                return '#aeb130'
            else if (boardID == 4)
                return '#64dd17'
            else if (boardID == 5)
                return '#0097a7'
            else if (boardID == 6)
                return '#00bfa5'
            else
                return ''
        },

        typeBadgeStyles(issueType){
            if (issueType.type == 1)
                return '#880e4e'
            else if (issueType.type == 2)
                return '#f50057'
            else if (issueType.type == 3)
                return '#8e24aa'
            else if (issueType.type == 4)
                return '#263238'
            else if (issueType.type == 5)
                return '#dd2c00'
            else if (issueType.type == 6)
                return '#00c853'
            else if (issueType.type == 7)
                return '#0097a7'
            else if (issueType.type == 8)
                return '#0288d1'
            else if (issueType.type == 9)
                return '#0208ff'
            else if (issueType.type == 10)
                return '#eeb600'
            else if (issueType.type == 10)
                return '#0e8e2e'
            else if (issueType.type == 11)
                return '#888'
            else
                return '#888888'
        },

        issueTypeText(issueType) {
            if (issueType.type == 1)
                return 'سرنخ (Lead)'
            else if (issueType.type == 2)
                return 'فرصت (Opportunity)'
            else if (issueType.type == 3)
                return 'ملاقات/جلسه/رویداد'
            else if (issueType.type == 4)
                return 'پیگیری (Ticket)'
            else if (issueType.type == 5)
                return 'ایراد (Bug)'
            else if (issueType.type == 6)
                return 'فعالیت (Task)'
            else if (issueType.type == 7)
                return 'لیست/شرح (Story)'
            else if (issueType.type == 8)
                return 'مجموعه/امکانات (Epic)'
            else if (issueType.type == 9)
                return 'پیام/تلفن (Message)'
            else if (issueType.type == 10)
                return 'گزارش/خبر (Report)'
            else if (issueType.type == 11)
                return 'سایر'
            else
                return 'سایر'
        },



    }



}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
